import { useState } from 'react';
import CorrectionModal from './CorrectionModal';

export default function useCorrectionModal() {
  const [isCorrectionModalVisible, setIsCorrectionModalVisible] = useState(false);

  const showCorrectionModal = () => {
    setIsCorrectionModalVisible(true);
  };

  const hideCorrectionModal = () => {
    setIsCorrectionModalVisible(false);
  };

  return {
    CorrectionModal,
    isCorrectionModalVisible,
    showCorrectionModal,
    hideCorrectionModal,
  };
}
